import React, {Component} from "react";
import {connect} from "react-redux";
import ChamberTopCalculations from "./topCalculations.component";
import {GLOBAL_PROJECT_TYPE_CHAMBER} from "../../../lib/types";
import PipeTopCalculations from "./pipeTopCalculations.component";


class TopCalculationsContainer extends Component {
    render() {
        const {
            lbl,
            lang,
            unit,
            content,
            chamberType,
            systemWidth,
            projectType,
            systemLength,
            pipeBedWidth,
            pipeBedLength,
            storageVolume,
            availableWidth,
            availableLength,
            requiredEndCaps,
            requiredChambers,
            numberOfPipeRows,
            totalStorageProvided,
            rectangularFootprint,
            lengthOutsideFittings,
            lengthBetweenFittings,
            lengthFittingsOnCenter,
        } = this.props;

        return (
            <React.Fragment>
                {
                    projectType === GLOBAL_PROJECT_TYPE_CHAMBER
                        ? (
                            <ChamberTopCalculations
                                lbl={lbl}
                                unit={unit}
                                lang={lang}
                                content={content}
                                chamberType={chamberType}
                                systemWidth={systemWidth}
                                systemLength={systemLength}
                                storageVolume={storageVolume}
                                availableWidth={availableWidth}
                                availableLength={availableLength}
                                requiredEndCaps={requiredEndCaps}
                                requiredChambers={requiredChambers}
                                rectangularFootprint={rectangularFootprint}
                                totalStorageProvided={totalStorageProvided}
                            />
                        ) : (
                            <PipeTopCalculations
                                lbl={lbl}
                                unit={unit}
                                pipeBedWidth={pipeBedWidth}
                                pipeBedLength={pipeBedLength}
                                numberOfPipeRows={numberOfPipeRows}
                                lengthOutsideFittings={lengthOutsideFittings}
                                lengthBetweenFittings={lengthBetweenFittings}
                                lengthFittingsOnCenter={lengthFittingsOnCenter}
                            />
                        )
                }
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        /* the calculations computed properties */
        projectType: state.globals.projectType,
        systemWidth: state.calculations.systemWidth,
        systemLength: state.calculations.systemLength,
        storageVolume: state.calculations.storageVolume,
        availableWidth: state.calculations.availableWidth,
        availableLength: state.calculations.availableLength,
        requiredEndCaps: state.calculations.requiredEndCaps,
        requiredChambers: state.calculations.requiredChambers,
        rectangularFootprint: state.calculations.rectangularFootprint,
        totalStorageProvided: state.calculations.totalStorageProvided,
        /* the chamber type is necessary for calculate the color of the right volume */
        chamberType: state.globals.chamberType,
        /* Values for pipe system */
        lbl: state.localization.lbl,
        unit: state.localization.unit,
        lang: state.localization.lang,
        content: state.localization.content,
        numberOfPipeRows: state.pipeBed.numberOfPipeRows,
        pipeBedWidth: state.pipeBed.stoneBedDimensions.width,
        pipeBedLength: state.pipeBed.stoneBedDimensions.height,
        lengthOutsideFittings: state.pipeBed.pipeBedDimensions.height,
        lengthBetweenFittings: state.pipeBed.rowBedDimensions.height,
        lengthFittingsOnCenter: state.pipeBed.centerFittingDimensions.height,
    };
};

export default connect(
    mapStateToProps, null,
)(TopCalculationsContainer);



// WEBPACK FOOTER //
// ./src/components/LayoutSections/TopCalculations/topCalculations.container.js